module.exports = __webpack_public_path__ + "img/logo-flag.38a48e23.svg";